import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { CommonSelect, Input } from "common/InputForm";
import { CustomButton } from "components/form";
import { toastMessage } from "utils/toastMessage";
import { IoCloudUploadOutline } from "react-icons/io5";
import { GoX } from "react-icons/go";
import Select from "react-select";
import { addBlogApi, getProductListApi } from "services/blog";
import useButtonLoader from "common/UseButtonLoader";
import JoditEditor from "jodit-react";
import CommonForm from "./CommonForm";
import { MultiSelect } from "react-multi-select-component";
const AddBlog = () => {
  const editor = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      placeholer: "",
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: {
        insertImageAsBase64URI: true,
      },
      controls: {
        font: {
          command: "fontname",
          list: {
            "'Open Sans',sans-serif": "Open Sans",
            "Helvetica,sans-serif": "Helvetica",
            "Arial,Helvetica,sans-serif": "Arial",
            "Georgia,serif": "Georgia",
            "Impact,Charcoal,sans-serif": "Impact",
            "Tahoma,Geneva,sans-serif": "Tahoma",
            "'Times New Roman',Times,serif": "Times New Roman",
            "Verdana,Geneva,sans-serif": "Verdana",
            "Consolas,monaco,monospace": "Consolas",
          },
        },
      },
    }),
    []
  );
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Save and Submit");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [productList, setProductList] = useState([])

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    bodyShape: [],
    bodyShapeValue: [],
    styleIdentity: [],
    styleIdentityValue: [],
    flauntParts: [],
    flauntPartsValue: [],
    downplayParts: [],
    downplayPartsValue: [],
    tag: "",
    category: "",
    images: [],
    thumb: "",
    isTrending: false, // Added isTrending key
    productIds: [],
    productLabelValue: []
  });
  const [selectedOptions, setSelectedOptions] = useState({
    paletteName: [],
    bodyShape: [],
    styleIdentity: [],
    flauntParts: [],
    downplayParts: [],
  })
  // console.log('selectedOptions', selectedOptions)
  // console.log('errors', errors)

  const [paletteName, setPaletteName] = useState([]);
  const paletteOptions = [
    { value: "Dark Winter", label: "Dark Winter" },
    { value: "Bright Winter", label: "Bright Winter" },
    { value: "True Winter", label: "True Winter" },
    { value: "Bright Spring", label: "Bright Spring" },
    { value: "Light Spring", label: "Light Spring" },
    { value: "True Spring", label: "True Spring" },
    { value: "Dark Autumn", label: "Dark Autumn" },
    { value: "Soft Autumn", label: "Soft Autumn" },
    { value: "True Autumn", label: "True Autumn" },
    { value: "Light Summer", label: "Light Summer" },
    { value: "Soft Summer", label: "Soft Summer" },
    { value: "True Summer", label: "True Summer" },
  ];
  const handlePaletteChange = (selectedOptions) => {
    setPaletteName(selectedOptions.map((option) => option.value));
    setErrors((pre) => ({
      ...pre,
      paletteName: null,
    }));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((pre) => ({
      ...pre,
      [name]: null,
    }));
  };
  const bodyShapeArray = [
    { value: "Round", label: "Round" },
    { value: "Triangle", label: "Triangle" },
    { value: "Hourglass", label: "Hourglass" },
    { value: "Rectangle", label: "Rectangle" },
    { value: "Inverted Triangle", label: "Inverted Triangle" },
  ];
  const styleIdentityArray = [
    { value: "Bold Boss", label: "Bold Boss" },
    { value: "Dreamy Diva", label: "Dreamy Diva" },
    { value: "Timeless Queen", label: "Timeless Queen" },
    { value: "Effortless Chic", label: "Effortless Chic" },
  ];

  const handleBodyShape = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      bodyShape: selectedOptions.map((option) => option.value),
      bodyShapeValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, bodyShapeValue: null }));
  };
  const handleStyleIdentity = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      styleIdentity: selectedOptions.map((option) => option.value),
      styleIdentityValue: selectedOptions,
    }));
    // setErrors((prevData) => ({ ...prevData, styleIdentityValue: null }));
  };
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const imagePreviews = files.map((file) => {
      return {
        file,
        preview: URL.createObjectURL(file),
      };
    });
    setFormData((prevData) => ({
      ...prevData,
      images: [...formData.images, ...imagePreviews],
    }));
    // console.log(formData, " Data")
    setErrors((pre) => ({
      ...pre,
      media: null,
    }));
  };
  // console.log(formData, "media Data")
  const handleImageRemove = (index) => {
    const updatedImages = formData.images.filter((_, i) => i !== index);
    // setFormData({ images: updatedImages });
    setFormData((prevData) => ({
      ...prevData,
      images: updatedImages
    }));
  };
  const handleThumbChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const thumbPreview = {
        file,
        preview: URL.createObjectURL(file),
      };
      setFormData((prevData) => ({
        ...prevData,
        thumb: thumbPreview,
      }));
      setErrors((pre) => ({
        ...pre,
        thumb: null
      }))
    }
  };

  const handleThumbRemove = () => {
    setFormData((prevData) => ({ ...prevData, thumb: null }));
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.tag) newErrors.tag = "Tag is required";

    // if (formData.bodyShape.length === 0)
    //   newErrors.bodyShape = "At least one bodyShape is required";
    // if (formData.bodyShapeValue.length === 0)
    //   newErrors.bodyShapeValue = "Body shape value is required";

    // if (formData.styleIdentity.length === 0)
    //   newErrors.styleIdentity = "At least one styleIdentity is required";

    // if (formData.styleIdentityValue.length === 0)
    //   newErrors.styleIdentityValue = "StyleIdentity value is required";

    // if (formData.flauntParts.length === 0)
    //   newErrors.flauntParts = "At least one flaunt part is required";
    // if (formData.flauntPartsValue.length === 0)
    //   newErrors.flauntPartsValue = "Flaunt parts value is required";

    // if (formData?.category === "lookbook" && formData.productLabelValue?.length === 0)
    //   newErrors.productLabelValue = "Products value is required";

    // if (formData.downplayParts.length === 0)
    //   newErrors.downplayParts = "At least one downplay part is required";
    // if (formData.downplayPartsValue.length === 0)
    //   newErrors.downplayPartsValue = "Downplay parts value is required";

    if (!formData.description)
      newErrors.description = "Description is required";
    if (!formData.category)
      newErrors.category = "Please select category  is required";

    // if (paletteName.length === 0)
    //   newErrors.paletteName = "Palette name is required";
    // Check if media (images or video) is provided
    if (formData.images.length === 0) {
      newErrors.media = "At least one image or video is required";
    }
    // Validate if more than one video is uploaded
    const videoFiles = formData.images.filter((file) =>
      file?.type?.startsWith("video/")
    );
    if (videoFiles && videoFiles.length > 1) {
      newErrors.media = "Only one video upload is allowed";
    }

    // If there is a video, check for the thumb
    if (videoFiles && videoFiles.length === 1 && (!formData.thumb || formData.thumb === "")) {
      newErrors.thumb = "Thumb is required for video ";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    // return false
    try {
      setButtonLoaders(true);
      let payLoad = {
        paletteName: selectedOptions.paletteName?.map((item) => item.value),
        flauntParts: selectedOptions.flauntParts?.map((item) => item.value),
        bodyShape: selectedOptions.bodyShape?.map((item) => item.value),
        downplayParts: selectedOptions.downplayParts?.map((item) => item.value),
        styleIdentity: selectedOptions.styleIdentity?.map((item) => item.value),
        // scrapeUrl: debouncedValue,
        // products: selectedProducts,
      };
      const formDatas = new FormData();
      formDatas.append("title", formData.title);
      formDatas.append("description", formData.description);
      formDatas.append("tag", formData.tag);
      formDatas.append("isTrending", formData.isTrending);
      formDatas.append("category", formData.category);


      formDatas.append("bodyShape", JSON.stringify(payLoad.bodyShape));
      formDatas.append("styleIdentity", JSON.stringify(payLoad.styleIdentity));
      formDatas.append("flauntParts", JSON.stringify(payLoad.flauntParts));
      formDatas.append("downplayParts", JSON.stringify(payLoad.downplayParts));
      formDatas.append("paletteName", JSON.stringify(payLoad.paletteName));

      formDatas.append("productIds", JSON.stringify(formData.productIds));

      formData.images.forEach((image) => {
        formDatas.append("media", image.file);
      });
      if (formData.thumb) formDatas.append("thumb", formData.thumb.file);
      // If a video exists, append the video (only one video can be uploaded)
      if (formData.video) {
        formDatas.append("media", formData.video.file);
      }
      const res = await addBlogApi(formDatas);
      if (res?.data?.status === 200) {
        toastMessage(res?.data?.message, "success", "addBlog");
        navigate(-1);
        setButtonLoaders(false);
      }
    } catch (e) {
      toastMessage(e.message, "error", "addBlog");
    } finally {
      setButtonLoaders(false);
    }
  };
  // Handle Checkbox Change
  const handleCheckboxChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      isTrending: e.target.checked,
    }));
  };

  const handleflauntParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      flauntParts: selectedOptions.map((option) => option.value),
      flauntPartsValue: selectedOptions,
    }));
    setErrors((pre) => ({
      ...pre,
      flauntPartsValue: null,
    }));
  };
  //---------product-onChange----------------
  const handleProduct = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      productIds: selectedOptions.map((option) => option.value),
      productLabelValue: selectedOptions,
    }));
    // setErrors((pre) => ({
    //   ...pre,
    //   productLabelValue: null,
    // }));
  };
  const handledownplayParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      downplayParts: selectedOptions.map((option) => option.value),
      downplayPartsValue: selectedOptions,
    }));
    setErrors((pre) => ({
      ...pre,
      downplayPartsValue: null,
    }));

  };
  const downplayArray = [
    { value: "Neckline", label: "Neckline" },
    { value: "Waist", label: "Waist" },
    { value: "Legs", label: "Legs" },
    { value: "Arms", label: "Arms" },
    { value: "Back", label: "Back" },
    { value: "Buttocks", label: "Buttocks" },
  ];
  const videoUploaded = formData.images.some((media) =>
    media.file.type.startsWith("video/")
  );

  // ------------user-listing-----------------
  useEffect(() => {
    const productList = async () => {
      try {
        const res = await getProductListApi();
        if (res?.data?.status === 200) {
          const user = res?.data?.data?.products
          // console.log('user', user)
          setProductList(user?.map((product) => ({ label: product?.productCode, value: product._id, })));
        } else {
          toastMessage(res?.data?.message || "Bad request", "error", "productElse");
        }
      } catch (e) {
        toastMessage(e.message, "error", "productCatch");
      }
    };
    productList()
  }, [])

  return (
    <div className="addClass">
      <div className="dashboard_title has_child">
        <h3>
          <Link to={"/blog-management"}>
            <IoMdArrowRoundBack />
          </Link>{" "}
          Add Blog
        </h3>
        <CustomButton
          type="button"
          className="button"
          ref={buttonLoaders}
          onClick={handleSubmit}
        >
          Save and Submit
        </CustomButton>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="form_field is_trending_wrap">
              <label className="label" htmlFor="isTrending">Is Trending</label>
              <input
                type="checkbox"
                id="isTrending"
                checked={formData.isTrending}
                onChange={handleCheckboxChange}
              />
            </div>

            <div className="form_field_wrap">
              <div className="form_field">
                <Input
                  type="text"
                  label="Title"
                  name="title"
                  placeholder="Enter Title"
                  value={formData.title}
                  onChange={handleInputChange}
                  error={errors.title}
                />
              </div>
              <div className="form_field">
                <label className="label">Category</label>
                <select
                  className="input form-control"
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                >
                  <option value=''>Select Category</option>
                  <option value="blog">Blog</option>
                  <option value="tutorial">Tips & Tutorials</option>
                  <option value="inspiration">Inspiration</option>
                  <option value="lookbook">Lookbook</option>
                </select>
                {errors && (
                  <span className="text-danger">{errors.category}</span>
                )}
              </div>
            </div>
            <div className="form_field">
              <Input
                type="text"
                label="Tag"
                name="tag"
                placeholder="Enter Tag"
                value={formData.tag}
                onChange={handleInputChange}
                error={errors.tag}
              />
            </div>


            {/* <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Style Identity</label>
                <Select
                  placeholder={<div>Select Style Identity</div>}
                  name="select"

                  className="multi_select multi-select"
                  value={formData.styleIdentityValue}
                  options={styleIdentityArray}
                  isMulti
                  onChange={handleStyleIdentity}
                />
                {errors && (
                  <div className="text-danger">{errors.styleIdentityValue}</div>
                )}
              </div>
              <div className="form_field">
                <label className="label">Body Shape</label>

                <Select
                  placeholder={<div>Select Body Shape</div>}
                  name="select"

                  className="multi_select multi-select"
                  value={formData.bodyShapeValue}
                  options={bodyShapeArray}
                  isMulti
                  onChange={handleBodyShape}
                />
                {errors && (
                  <div className="text-danger">{errors.bodyShapeValue}</div>
                )}
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Flaunt Parts</label>
                <Select
                  placeholder={<div>Select Flaunt Parts</div>}
                  name="select"
                  className="multi-select multi_select"
                  value={formData.flauntPartsValue}
                  options={downplayArray}
                  isMulti
                  onChange={handleflauntParts}
                />
                {errors && (
                  <span className="text-danger">{errors.flauntPartsValue}</span>
                )}
              </div>
              <div className="form_field">
                <label className="label">Downplay Parts</label>
                <Select
                  placeholder={<div>Select Downplay Parts</div>}
                  name="select"
                  className="multi_select multi-select"
                  value={formData.downplayPartsValue}
                  options={downplayArray}
                  isMulti
                  onChange={handledownplayParts}
                />
                {errors && (
                  <span className="text-danger">
                    {errors.downplayPartsValue}
                  </span>
                )}
              </div>

            </div> */}

            {/* <formData, setFormData */}
            <CommonForm {...{ selectedOptions, setSelectedOptions, errors, setErrors }} />

            {formData?.category === "lookbook" &&
              <div className="form_field_wrap">
                <div className="form_field">
                  <label className="label">Select Product</label>
                  <MultiSelect
                    className="w-100"
                    name='productLabelValue'
                    options={productList}
                    value={formData.productLabelValue}
                    onChange={handleProduct}
                    overrideStrings={{
                      selectSomeItems: "Select product"
                    }}
                  />
                  {/* <CommonSelect
                    placeholder={<div>Select product</div>}
                    name="productLabelValue"
                    className="multi-select multi_select"
                    value={formData.productLabelValue}
                    options={productList}
                    isMulti
                    onChange={handleProduct}
                  // error={errors.productLabelValue}
                  /> */}
                  {/* {errors && (
                    <span className="text-danger">{errors.productLabelValue}</span>
                  )} */}
                </div>
              </div>
            }





            {/* --------------Description------------------- */}
            <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Description</label>
                <JoditEditor
                  ref={editor}
                  value={formData.description}
                  config={config}
                  tabIndex={1}
                  onBlur={(newContent) => {
                    setFormData((prevData) => ({
                      ...prevData,
                      description: newContent,
                    }));
                    setErrors((prevData) => ({
                      ...prevData,
                      description: null,
                    }));
                  }}

                />
                {errors && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </div>

              <div className="form_field">
                <label className="label">
                  Upload Media{" "}
                  <span style={{ fontSize: "12px" }} className="text-danger">
                    (Recommended size: 414x233 pixels)
                  </span>
                </label>

                <div className="upload_button_wrap">
                  <label
                    htmlFor="upload_images"
                    className="upload_button input"
                  >
                    <IoCloudUploadOutline className="icon" />
                    <input
                      type="file"
                      multiple
                      accept="image/*, video/*"
                      onChange={handleImageChange}
                      id="upload_images"
                    />
                    <span className="text">Select file to upload</span>
                  </label>
                  <div className="image_preview_wrap">
                    {formData.images.map((media, index) => (
                      <div className="image_preview" key={index}>
                        {/* Display image preview */}
                        {media.file.type.startsWith("image/") ? (
                          <img src={media.preview} alt="Preview" width="100" />
                        ) : (
                          // Display video preview
                          <video width="100" controls>
                            <source
                              src={media.preview}
                              type={media.file.type}
                            />
                            Your browser does not support the video tag.
                          </video>
                        )}
                        <button
                          type="button"
                          className="remove_image_button"
                          onClick={() => handleImageRemove(index)}
                        >
                          <GoX />
                        </button>
                      </div>
                    ))}
                    {errors.media && (
                      <span className="text-danger">{errors.media}</span>
                    )}
                  </div>
                </div>

              </div>
              {/* Thumbnail upload */}
              {videoUploaded && (
                <div className="form_field">
                  <label className="label">Upload Thumbnail</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleThumbChange}
                  />
                  {formData.thumb && (
                    <div>
                      <img
                        src={formData.thumb.preview}
                        alt="Thumbnail Preview"
                      />
                      <button type="button" onClick={handleThumbRemove}>
                        <GoX />
                      </button>
                    </div>
                  )}
                  {errors.thumb && (
                    <span className="text-danger">{errors.thumb}</span>
                  )}
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddBlog;
